/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { Tooltip } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useCommonCitizenContext } from '../../areas/citizen/citizen-context';
import { CitizenNameHighlight } from '../../areas/citizen/common/citizen-name-highlight';
import { formatCpr } from '../../utilities';
import { useCrmHostUrlContext } from '../resource-redirect/crm-host-url-context';
import { createUrlToActualResource } from '../resource-redirect/resource-url-builder';
import { useAllowedActions } from '../../authentication/use-allowed-actions';
import { ResourceOperations, ResourceTypes } from '../../authentication/resources';
import { medicalCollaborationTabPathName, serviceProviderDetailsTabPathName } from '../../areas/citizen/serviceprovider/citizen-serviceprovider-area-pathnames';

export interface ICitizenNameDisplayProps {
  cpr?: string;
  fullName?: string;
  preferredName?: string;
  citizenId?: string;
  isSocialProviderContext?: boolean;
  spuId?: string;
}

export function CitizenNameDisplay(props: ICitizenNameDisplayProps) {
  const citizenHeader = useCommonCitizenContext();
  const hasSocialProviderCitizenRead = useAllowedActions().isAnyAllowed([
    { resourceType: ResourceTypes.SocialProviderCitizen, resourceOperation: ResourceOperations.Read },
  ]);
  let citizenId: string | undefined;
  let fullName;
  let preferredName;
  let cpr;

  if (citizenHeader === null || citizenHeader === undefined || Object.keys(citizenHeader).length === 0) {
    citizenId = props.citizenId;
    fullName = props.fullName;
    preferredName = props.preferredName;
    cpr = props.cpr;
  } else {
    citizenId = citizenHeader.citizenId;
    fullName = citizenHeader.fullName;
    preferredName = citizenHeader.preferredName;
    cpr = citizenHeader.cpr;
  }
  const { url: crmBaseUrl } = useCrmHostUrlContext();
  const [url, setUrl] = useState('');
  useEffect(() => {
    let isMounted = true;

    async function getUrl() {
      if (citizenId) {
        const resourceName = props.isSocialProviderContext ? 'socialprovidercitizen' : 'contact';
        const searchParams = props.spuId ? new URLSearchParams({ spuid: props.spuId }) : undefined;
        const landingTab = hasSocialProviderCitizenRead ? serviceProviderDetailsTabPathName : medicalCollaborationTabPathName;
        const redirectUrl = await createUrlToActualResource(resourceName, citizenId, window.location.origin, searchParams, undefined, landingTab);

        if (redirectUrl && isMounted) {
          setUrl(redirectUrl);
        }
      }
    }

    getUrl();
    // eslint-disable-next-line no-return-assign
    return () => {
      isMounted = false;
    };
  }, [citizenId, crmBaseUrl, props.isSocialProviderContext, props.spuId, hasSocialProviderCitizenRead]);

  if (!citizenId && !cpr && !fullName) return null;

  return (
    <>
      {fullName ? <CitizenNameHighlight preferredName={preferredName} fullName={fullName} /> : fullName}{' '}
      {url ? (
        <span>
          (
          <a href={url} target="_blank" rel="noreferrer">
            <Tooltip title="Åbn borger i ny fane">
              <span>{formatCpr(cpr)}</span>
            </Tooltip>
          </a>
          )
        </span>
      ) : (
        <span>{formatCpr(cpr)}</span>
      )}
    </>
  );
}
